// всё, что связано с модалкой c формой
const bodyContainer = document.querySelector(".body-container");
const softDownloadButtons = document.querySelectorAll(
  ".landing-page__soft-download"
);
const bookDownloadButtons = document.querySelectorAll(
  ".landing-page__book-download"
);
const videoDownloadButtons = document.querySelectorAll(
  ".landing-page__video-download"
);
const articleDownloadButtons = document.querySelectorAll(
  ".landing-articles__link"
);
const modal = document.querySelector(".form-modal");

if (softDownloadButtons) {
  softDownloadButtons.forEach((it) => {
    it.addEventListener("click", (evt) => {
      evt.preventDefault();
      modal.querySelector(".site-modal__title").innerText =
        "Доступ к бесплатной пробной версии Solid Edge на 3 месяца";
      modal.querySelector(".site-modal__description").innerText =
        "Чтобы получить доступ, оставьте свои контактные данные";
      modal.querySelector("#type").value = "soft";
      modal.querySelector("#hidden_item_name").value = "";
      modal.querySelector("#page_link").value = window.location.href;
      modal.querySelector("#form_type").value = it.innerText;
      modal.classList.add("site-modal--opened");
      bodyContainer.classList.add("body-container--no-scroll");
    });
  });
}

if (bookDownloadButtons) {
  bookDownloadButtons.forEach((it) => {
    it.addEventListener("click", (evt) => {
      evt.preventDefault();
      modal.querySelector(".site-modal__title").innerText =
        "Доступ к книгам по системам Siemens Digital Industries Software";
      modal.querySelector(".site-modal__description").innerText =
        "Чтобы получить доступ к книгам, оставьте свои контактные данные";
      const bookTitle = it.querySelector(".landing-book__desc").innerText;
      modal.querySelector("#type").value = "book";
      modal.querySelector("#hidden_item_name").value = bookTitle;
      modal.querySelector("#page_link").value = window.location.href;
      modal.querySelector("#form_type").value = "Скачать книгу";
      modal.classList.add("site-modal--opened");
      bodyContainer.classList.add("body-container--no-scroll");
    });
  });
}

if (videoDownloadButtons) {
  videoDownloadButtons.forEach((it) => {
    it.addEventListener("click", (evt) => {
      evt.preventDefault();
      const videoName = it.querySelector(".landing-cards__item-desc").innerText;
      modal.querySelector(
        ".site-modal__title"
      ).innerText = `Доступ к видеозаписи ${videoName.slice(
        videoName.indexOf('"'),
        videoName.length
      )}`;
      modal.querySelector(".site-modal__description").innerText =
        "Чтобы получить доступ к видеозаписи, оставьте свои контактные данные";
      modal.querySelector("#type").value = "video";
      modal.querySelector("#hidden_item_name").value = videoName;
      modal.querySelector("#page_link").value = window.location.href;
      modal.querySelector("#form_type").value = "Перейти к видео";
      modal.classList.add("site-modal--opened");
      bodyContainer.classList.add("body-container--no-scroll");
    });
  });
}

if (articleDownloadButtons) {
  articleDownloadButtons.forEach((it) => {
    it.addEventListener("click", (evt) => {
      evt.preventDefault();
      modal.querySelector(".site-modal__title").innerText = "Доступ к статье";
      modal.querySelector(".site-modal__description").innerText =
        "Чтобы получить доступ, оставьте свои контактные данные";
      modal.querySelector("#type").value = "article";
      modal.querySelector("#hidden_item_name").value = it.innerText;
      modal.querySelector("#page_link").value = window.location.href;
      modal.querySelector("#form_type").value = it.innerText;
      modal.classList.add("site-modal--opened");
      bodyContainer.classList.add("body-container--no-scroll");
    });
  });
}

// модалки с видео
const watchVideoButtons = document.querySelectorAll(
  ".landing-page__video-button"
);
const videoModal = document.querySelector(".video-modal");
watchVideoButtons.forEach((it) =>
  it.addEventListener("click", (evt) => {
    evt.preventDefault();
    const videoLink = it.getAttribute("data-link");
    videoModal.classList.add("site-modal--opened");
    bodyContainer.classList.add("body-container--no-scroll");
    const frame = videoModal.querySelector("iframe");
    frame.src = videoLink;
  })
);

//Скролл до секций
const sectionScroll = (from) => {
  let fromLink = document.querySelector(from);
  if (fromLink) {
    let href = fromLink.getAttribute("href");
    fromLink.addEventListener("click", (e) => {
      e.preventDefault();

      let elementPosition = document.querySelector(href).getBoundingClientRect()
        .top;

      window.scrollBy({
        top: elementPosition,
        behavior: "smooth",
      });
    });
  }
};

sectionScroll(".landing-intro__arrow");

//Аккордеон
const openItem = (event) => {
  let tool = event.parentNode;
  let contentBox = tool.childNodes[3];
  let content = contentBox.childNodes[1];
  let heightContent = content.offsetHeight;
  if (tool.classList.contains("landing-tools__tool--act")) {
    contentBox.style.height = "0px";
  } else {
    contentBox.style.height = heightContent + 30 + "px";
  }
  tool.classList.toggle("landing-tools__tool--act");
};

let toolElement = document.querySelectorAll(".landing-tools__tool-row");

if (toolElement) {
  //проверка на наличие элемента на странице
  for (let i = 0; i < toolElement.length; i++) {
    toolElement[i].addEventListener("click", (e) => {
      openItem(e.currentTarget);
    });
  } //костыль для применения CLICK ко всем элементам с одинаковым классом
}
